import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import TextField from "material-ui/TextField";
import Modal from "../generalcomponets/modal-mobile";

const mapState = (state) => {
	return {
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

const validate = (campos) => {
	const errors = {};

	if(!campos.nombre) {
		errors.nombre = "Campo requerido.";
	} else if (/^\s+/.test(campos.nombre)) {
		errors.nombre = "Campo requerido.";
	}

	if(!campos.email) {
		errors.email = "Campo requerido.";
	}

	if (!campos.email) {
		errors.email = "Campo requerido.";
	} else {
		campos.email =  campos.email.replace(" ","");
		if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(campos.email)) {
			errors.email = "El correo electrónico no es válido. Favor de verificarlo.";
		}
	}

	return errors;
};

const space = value => {
  let text = (value != undefined) ? value.replace(/\s/g, '') : '';
  return text.toUpperCase();
};

const onSubmitFail = (errors,dispatch,submitError,props) => {
	if(errors.email === "Campo requerido." || errors.nombre === "Campo requerido.") {
		dispatch({ "type": "EVENT_ACCESOFAMILIAR_AGREGAR-VACIOS", "dispositivo": props.dispositivo });
	}
	if(errors.email != "Campo requerido."){
		dispatch({ "type": "AF_SET_EVENT", "evento": "DatosIncorrectos-AgregarInvitado", "dispositivo": props.dispositivo});
	}
};

const campoSettings = {
	fontFamily:'Roboto',
	fontStyle: 'normal',
	fontWeight: 'normal',
	mixBlendMode: 'normal',
};

const floatingLabelStyleSettings = {
	...campoSettings,
	lineHeight: '24px',
	letterSpacing: '0.5px',
	color: '#33445F',
};

const floatingLabelFocusStyleSettings = {
	...campoSettings,
	lineHeight: '16px',
	letterSpacing: '0.4px',
	color: '#FF6B0B',
};

const renderField = ({ ...custom, input, label, type, focus, blur, param, cerrar, max, change, meta: { touched, error, warning } }) => {
  
  return (
    <MuiThemeProvider>
      <TextField
        floatingLabelText={label}
        fullWidth={true}
        underlineStyle={{ borderColor: '#AAC3EE' }}
        underlineFocusStyle={{ borderColor: '#FF6B0B' }}
        floatingLabelStyle={floatingLabelStyleSettings}
        floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
        type={type}
        onFocus={focus}
        onBlur={(event) => { input.onBlur(event); blur(event); }}
        onChange={(event) => {input.onChange(event); change(event); }}
        maxLength={max}
        errorText={touched && error}
      />
    </MuiThemeProvider>
	);
};

class InvitarForm extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      modalOpen: true
    }
  }

  // state = {
  //   modalOpen: true,
  // }

  handleChange = (param) => {
    validate(param.target.value);
  }

  handleBlur = (param) => {
    validate(param.target.value)
  }

	cancel = () => {
    this.props.tagManager({ "type": "EVENT_ACCESOFAMILIAR_AGREGAR-CANCELAR", "dispositivo": this.props.dispositivo });
    this.props.reset();
    this.setState({ modalOpen: false });
  }

	render () {
    const { handleSubmit, pristine, reset, submitting } = this.props;
		return (
      <div>
        {this.state.modalOpen &&
          <div id="modalInvitar" className="GNP-modal" onClick={this.props.handler.bind(this)}>
            <div className="GNP-modal-content">
              <div className="GNP-modal-body">
                <form onSubmit={handleSubmit}>
                  <div>
                    <h5 className="title-mail">Correo de invitación</h5>
                    <div className="row">
                      <div className="col-xs-12">
                        <div className="text-access">
                          <p style={{"textAlign":"justify"}}>
                            Ingresa el nombre y correo electrónico de tu invitado.
                            <br />
                            IMPORTANTE: Si tu invitado ya está registrado en el Portal Soy Cliente o en la aplicación Soy Cliente GNP, ingresa el correo asociado a su cuenta.
                          </p>
                        </div>
                        <div className="row">
                          <div className="col-xs-12 col-md-10 col-md-offset-1">
                            <div className="row">
                              <div className="col-xs-12">
                                <div className="input-wrap input-margin">
                                  <Field
                                    name="nombre"
                                    label="Nombre(s)"
                                    component={renderField}
                                    blur={this.handleBlur.bind(this)}
                                    change={this.handleChange.bind(this)}
                                    normalize={space}
                                    type="text"
                                    max="50"
                                  />
                                </div>
                              </div>
                              <div className="col-xs-12">
                                <div className="input-wrap input-margin">
                                  <Field
                                    name="email"
                                    label="Correo electrónico"
                                    component={renderField}
                                    blur={this.handleBlur.bind(this)}
                                    change={this.handleChange.bind(this)}
                                    normalize={space}
                                    type="text"
                                    max="50"
                                  />
                                </div>
                              </div>
                              <div className="col-xs-12">
                                <div className="text-center aceptar-cancelar-btn">
                                  <a onClick={handleSubmit} className="orange-movil">Siguiente</a>
                                </div>
                              </div>
                              {/*<div className="col-xs-12">
                                <div className="text-center aceptar-cancelar-btn">
                                  <a onClick={this.cancel.bind(this)} className="btn-modal">Cancelar</a>
                                </div>
                              </div>*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        }
      </div>
		)
	}
}

InvitarForm = reduxForm({form: "acceso-familiar-invitar", validate,onSubmitFail})(InvitarForm);

export default connect(mapState, mapDispatch)(InvitarForm);



// WEBPACK FOOTER //
// ./src/acceso-familiar/invitarMovil.frm.js